import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import HorizontalLine from '../HorizontalLine/HorizontalLine';
import CustomerLogo from '../CustomerLogo/CustomerLogo';
import styled from 'styled-components';
import { LabelBox } from '../Box/LabelBox';
import { TextInputBox } from '../Box/TextInputBox';
import { HoverTip } from '../HoverTip/HoverTip';
import { axiosInstance } from '../../functions/axios';
import { useTranslation } from 'react-i18next';
import { setRegistrationDetails } from '../../actions/index';
import { NativeDropdown } from '../NativeDropdown/NativeDropdown';

import {
    Box,
    Checkbox,
    Button,
    FieldLabel,
    Field,
    Modal,
    Icon,
    Grid,
    ReactSelect,
    Text,
    TextInput,
    Typography,
    ProgressTracker,
    ContextualNotification,
} from '@blueprint/ui';

import { InlineNotificationComponent } from '../Notification/InlineNotificationComponent';
import { NativeCheckbox } from '../NativeCheckbox/NativeCheckbox';

const StyledDiv = styled.div`
    padding-top: 100px;
    margin-left: 5vw;
    margin-right: 5vw;
    padding-bottom: 5em;
`;

const Registration1 = ({ location }) => {
    const { t } = useTranslation();
    const history = useHistory();
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const globalState = useSelector((state) => state);
    const FETCH_QUES_URL = process.env.REACT_APP_FETCH_QUES_URL;
    const VALIDATE_USER_URL = process.env.REACT_APP_VALIDATE_USER_URL;
    // For Confirm Checkbox
    const [saveDetails, setSaveDetails] = useState(false);
    const [autoPay, setAutoPay] = useState(false);

    // This state variable stores the three questions and answers
    const [secDetails, setSecDetails] = useState({
        queOne: null,
        queTwo: null,
        queThree: null,
        ansOne: null,
        ansTwo: null,
        ansThree: null,
    });

    const [showError, setShowError] = useState({
        ansOne: false,
        ansTwo: false,
        ansThree: false,
        queOne: false,
        queTwo: false,
        queThree: false,
        ansError: false,
        showSDerror: false,
        newPwdError: false,
        cnfPwdError: false,
    });

    const [showErrorLabel, setShowErrorLabel] = useState({
        ansOneLabel: '',
        ansTwoLabel: '',
        ansThreeLabel: '',
        ansError: '',
        showSDerrorLabel: '',
        newPwdErrorLabel: '',
        cnfPwdErrorLabel: '',
    });

    // This state variable stores the new password
    const [newPwd, setNewPwd] = useState('');

    // This state variable stores the confirmed new password
    const [cnfPwd, setCnfPwd] = useState('');
    const [queList, setQueList] = useState([]);

    useEffect(() => {
        if (location.state !== undefined) {
            if (location.state.comingBack === true) {
                console.log('Details while coming back from Registration page 2', location.state);
                setSecDetails({
                    ...secDetails,
                    queOne: location.state.allDetails.queOne,
                    queTwo: location.state.allDetails.queTwo,
                    queThree: location.state.allDetails.queThree,
                    ansOne: location.state.allDetails.ansOne,
                    ansTwo: location.state.allDetails.ansTwo,
                    ansThree: location.state.allDetails.ansThree,
                });
                setNewPwd(location.state.newPassword);
                setCnfPwd(location.state.confirmPassword);
                setAutoPay(location.state.autoPayCb);
                setSaveDetails(location.state.futureDetails);
            }
        }

        const fetchQuestions = async () => {
            try {
                const response = await axiosInstance({
                    method: 'get',
                    url: FETCH_QUES_URL,
                });
                if (response.status === 200) {
                    setQueList(
                        response.data.map((que) => ({
                            label: que.question,
                            value: que.question,
                        }))
                    );
                }
            } catch (error) {
                console.log('error coming from fetchQuestions');
            }
        };
        fetchQuestions();
    }, []);

    useEffect(() => {
        if (!globalState.beneDetails.details.isLogged || globalState.beneDetails.registeredUser) {
            history.push('/');
        }
    }, [globalState, history]);

    const handleSaveDetails = (event) => {
        setSaveDetails(event.target.checked);
    };

    const handleAutoPay = (event) => {
        setAutoPay(event.target.checked);
    };

    const footerHeight = globalState.beneDetails.footerHeight;

    const progressBarData = ['Setup', 'Verify'];

    const handleQueOne = (SelectedOption) => {
        setShowError({ ...showError, queOne: false });
        if (SelectedOption.value === secDetails.queTwo?.value || SelectedOption.value === secDetails.queThree?.value) {
            setOpen(true);
            setSecDetails({ ...secDetails, queOne: { label: '', value: '' } });
            // setShowError({ ...showError, queOne: true }); // Question might be set in state before, Make it empty again
            // Show blank on UI
            return;
        } else {
            setSecDetails({
                ...secDetails,
                queOne: SelectedOption,
            });
        }
    };

    const handleQueTwo = (SelectedOption) => {
        setShowError({ ...showError, queTwo: false });
        if (SelectedOption.value === secDetails.queOne?.value || SelectedOption.value === secDetails.queThree?.value) {
            setOpen(true);
            // setShowError({ ...showError, queTwo: true });
            setSecDetails({ ...secDetails, queTwo: { label: '', value: '' } });
            return;
        } else {
            setSecDetails({
                ...secDetails,
                queTwo: SelectedOption,
            });
        }
    };

    const handleQueThree = (SelectedOption) => {
        setShowError({ ...showError, queThree: false });
        if (SelectedOption.value === secDetails.queOne?.value || SelectedOption.value === secDetails.queTwo?.value) {
            setOpen(true);
            setSecDetails({ ...secDetails, queThree: { label: '', value: '' } });
            // setShowError({ ...showError, queThree: true });
            return;
        } else {
            setSecDetails({
                ...secDetails,
                queThree: SelectedOption,
            });
        }
    };

    const validatePwd = (finalError, finalErrorLabel) => {
        let pattern = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\-!@#$%^&*|(~=._)?]).{8,30}$');
        if (newPwd === null || newPwd.trim() === '') {
            finalError.newPwdError = true;
            finalErrorLabel.newPwdErrorLabel = t('registrationPageOne.error1');
        } else if (!pattern.test(newPwd)) {
            finalError.newPwdError = true;
            finalErrorLabel.newPwdErrorLabel = t('registrationPageOne.error2');
        } else {
            finalError.newPwdError = false;
        }
        setShowError({
            ...showError,
            cnfPwdError: finalError.cnfPwdError,
        });
        setShowErrorLabel({
            ...showErrorLabel,
            cnfPwdErrorLabel: finalErrorLabel.cnfPwdErrorLabel,
        });
        return [finalError, finalErrorLabel];
    };

    const validateCnfPwd = (finalError, finalErrorLabel) => {
        if (cnfPwd === null || cnfPwd.trim() === '') {
            finalError.cnfPwdError = true;
            finalErrorLabel.cnfPwdErrorLabel = t('registrationPageOne.error3');
        } else if (cnfPwd.trim() !== '' && newPwd !== null && newPwd.trim() !== '' && cnfPwd !== newPwd) {
            finalError.cnfPwdError = true;
            finalErrorLabel.cnfPwdErrorLabel = t('registrationPageOne.error8');
        } else {
            finalError.cnfPwdError = false;
        }
        setShowError({
            ...showError,
            cnfPwdError: finalError.cnfPwdError,
        });
        setShowErrorLabel({
            ...showErrorLabel,
            cnfPwdErrorLabel: finalErrorLabel.cnfPwdErrorLabel,
        });
        return [finalError, finalErrorLabel];
    };

    const validateAnsOne = (finalError, finalErrorLabel) => {
        if (secDetails.ansOne === null || secDetails.ansOne.trim() === '') {
            finalError.ansOne = true;
            finalErrorLabel.ansOneLabel = t('registrationPageOne.error5');
        } else if (secDetails.ansOne?.length < 3) {
            finalError.ansOne = true;
            finalErrorLabel.ansOneLabel = t('registrationPageOne.error6');
        } else {
            finalError.ansOne = false;
        }
        setShowError({
            ...showError,
            ansOne: finalError.ansOne,
        });
        setShowErrorLabel({
            ...showErrorLabel,
            ansOneLabel: finalErrorLabel.ansOneLabel,
        });
        return [finalError, finalErrorLabel];
    };

    const validateAnsTwo = (finalError, finalErrorLabel) => {
        if (secDetails.ansTwo === null || secDetails.ansTwo.trim() === '') {
            finalError.ansTwo = true;
            finalErrorLabel.ansTwoLabel = t('registrationPageOne.error5');
        } else if (secDetails.ansTwo?.length < 3) {
            finalError.ansTwo = true;
            finalErrorLabel.ansTwoLabel = t('registrationPageOne.error6');
        } else {
            finalError.ansTwo = false;
        }
        setShowError({
            ...showError,
            ansTwo: finalError.ansTwo,
        });
        setShowErrorLabel({
            ...showErrorLabel,
            ansTwoLabel: finalErrorLabel.ansTwoLabel,
        });
        return [finalError, finalErrorLabel];
    };

    const validateAnsThree = (finalError, finalErrorLabel) => {
        if (secDetails.ansThree === null || secDetails.ansThree.trim() === '') {
            finalError.ansThree = true;
            finalErrorLabel.ansThreeLabel = t('registrationPageOne.error5');
        } else if (secDetails.ansThree?.length < 3) {
            finalError.ansThree = true;
            finalErrorLabel.ansThreeLabel = t('registrationPageOne.error6');
        } else {
            finalError.ansThree = false;
        }
        setShowError({
            ...showError,
            ansThree: finalError.ansThree,
        });
        setShowErrorLabel({
            ...showErrorLabel,
            ansThreeLabel: finalErrorLabel.ansThreeLabel,
        });
        return [finalError, finalErrorLabel];
    };

    const validateQueOne = (finalError, finalErrorLabel) => {
        if (secDetails.queOne === null || secDetails.queOne?.value === '') {
            finalError.queOne = true;
            finalErrorLabel.queOneLabel = t('registrationPageOne.error7');
        } else {
            finalError.queOne = false;
        }
        setShowError({
            ...showError,
            queOne: finalError.queOne,
        });
        setShowErrorLabel({
            ...showErrorLabel,
            queOneLabel: finalErrorLabel.queOneLabel,
        });
        return [finalError, finalErrorLabel];
    };

    const validateQueTwo = (finalError, finalErrorLabel) => {
        if (secDetails.queTwo === null || secDetails.queTwo?.value === '') {
            finalError.queTwo = true;
            finalErrorLabel.queTwoLabel = t('registrationPageOne.error7');
        } else {
            finalError.queTwo = false;
        }
        setShowError({
            ...showError,
            queTwo: finalError.queTwo,
        });
        setShowErrorLabel({
            ...showErrorLabel,
            queTwoLabel: finalErrorLabel.queTwoLabel,
        });
        return [finalError, finalErrorLabel];
    };

    const validateQueThree = (finalError, finalErrorLabel) => {
        if (secDetails.queThree === null || secDetails.queThree?.value === '') {
            finalError.queThree = true;
            finalErrorLabel.queThreeLabel = t('registrationPageOne.error7');
        } else {
            finalError.queThree = false;
        }
        setShowError({
            ...showError,
            queThree: finalError.queThree,
        });
        setShowErrorLabel({
            ...showErrorLabel,
            queThreeLabel: finalErrorLabel.queThreeLabel,
        });
        return [finalError, finalErrorLabel];
    };

    const callContinue = () => {
        // Validate question selected
        let validated = true;
        let finalError = {
            ansOne: false,
            ansTwo: false,
            ansThree: false,
            queOne: false,
            queTwo: false,
            queThree: false,
            ansError: false,
            showSDerror: false,
            newPwdError: false,
            cnfPwdError: false,
        };
        let finalErrorLabel = {
            ansOneLabel: '',
            ansTwoLabel: '',
            ansThreeLabel: '',
            queOneLabel: '',
            queTwoLabel: '',
            queThreeLabel: '',
            ansError: '',
            showSDerrorLabel: '',
            newPwdErrorLabel: '',
            cnfPwdErrorLabel: '',
        };

        // Array of flag json and error message json
        [finalError, finalErrorLabel] = validatePwd(finalError, finalErrorLabel);
        [finalError, finalErrorLabel] = validateCnfPwd(finalError, finalErrorLabel);

        [finalError, finalErrorLabel] = validateAnsOne(finalError, finalErrorLabel);
        [finalError, finalErrorLabel] = validateAnsTwo(finalError, finalErrorLabel);
        [finalError, finalErrorLabel] = validateAnsThree(finalError, finalErrorLabel);

        [finalError, finalErrorLabel] = validateQueOne(finalError, finalErrorLabel);
        [finalError, finalErrorLabel] = validateQueTwo(finalError, finalErrorLabel);
        [finalError, finalErrorLabel] = validateQueThree(finalError, finalErrorLabel);

        if (saveDetails !== true) {
            finalError.showSDerror = true;
            finalErrorLabel.showSDerrorLabel = t('registrationPageOne.error10');
            validated = false;
        } else {
            finalError.showSDerror = false;
        }

        if (
            (secDetails.ansOne !== null && secDetails.ansOne !== '' && secDetails.ansOne === secDetails.ansTwo) ||
            (secDetails.ansThree !== null && secDetails.ansThree !== '' && secDetails.ansOne === secDetails.ansThree) ||
            (secDetails.ansTwo !== null && secDetails.ansTwo !== '' && secDetails.ansTwo === secDetails.ansThree)
        ) {
            finalError.ansError = true;
            finalErrorLabel.ansError = t('registrationPageOne.error9');
            validated = false;
        }

        validated =
            validated &&
            !finalError.ansOne &&
            !finalError.ansTwo &&
            !finalError.ansThree &&
            !finalError.queOne &&
            !finalError.queTwo &&
            !finalError.queThree &&
            !finalError.showSDerror &&
            !finalError.newPwdError &&
            !finalError.cnfPwdError;

        if (validated) {
            // VALIDATE USER API CALL
            const validateUser = async () => {
                try {
                    const response = await axiosInstance.post(
                        VALIDATE_USER_URL,
                        JSON.stringify({
                            autoPay: autoPay,
                            confirmPassword: cnfPwd,
                            password: newPwd,
                            qa1: {
                                answer: secDetails.ansOne,
                                question: secDetails.queOne.label,
                            },
                            qa2: {
                                answer: secDetails.ansTwo,
                                question: secDetails.queTwo.label,
                            },
                            qa3: {
                                answer: secDetails.ansThree,
                                question: secDetails.queThree.label,
                            },
                        })
                    );

                    if (response.status === 200) {
                        let registrationDetails = {
                            secDetails: secDetails,
                            password: newPwd,
                            confirmationPassword: cnfPwd,
                            saveDetails: saveDetails,
                            autopay: autoPay,
                        };
                        dispatch(setRegistrationDetails(registrationDetails));
                        history.push({
                            pathname: '/registration2',
                            state: {
                                allDetails: secDetails,
                                newPassword: newPwd,
                                confirmPassword: cnfPwd,
                                futureDetails: saveDetails,
                                autoPayCb: autoPay,
                            },
                        });
                    }
                } catch (error) {
                    setShowError({
                        ...showError,
                        ansError: true,
                    });
                    setShowErrorLabel({
                        ...showErrorLabel,
                        ansError: error.response.data.errors[0].message,
                    });

                    console.log('it is coming here in error', error.response.data.errors[0].message);
                }
            };
            validateUser();
        } else {
            let elementsWithError = document.getElementsByClassName('hasError');
            setTimeout(() => {
                if (elementsWithError !== null && elementsWithError !== undefined && elementsWithError.length > 0) {
                    console.log('Logging first element having class hasError', elementsWithError[0]);

                    elementsWithError[0].focus();
                }
            }, 200);
        }

        setShowError(finalError);
        setShowErrorLabel(finalErrorLabel);
        console.log('Final errors after validation are', finalError, finalErrorLabel);
    };

    useEffect(() => {
        console.log('Logging Security details', secDetails);
    }, [secDetails]);

    useEffect(() => {
        console.log('Logging Questions list', queList);
    }, [queList]);

    return (
        <StyledDiv style={{ paddingBottom: `${footerHeight + 20}px` }} role='main'>
            <Grid container>
                <CustomerLogo />
                <Grid container>
                    <Box>
                        <Box borderLeft='3px solid red' margin='0 0 2vw 0' paddingLeft='10px'>
                            <Typography variant='h1' className='page-title' tabIndex='-1'>
                                {t('registrationPageOne.section_title')}
                            </Typography>
                        </Box>
                    </Box>
                </Grid>

                <Grid item xs={12} sm={7}>
                    <Box width='auto' marginTop={['15px', '15px', '15px', '15px']}>
                        <ProgressTracker activeIndex={0} data={progressBarData} />
                    </Box>
                </Grid>

                {showError.ansError === true ? (
                    <Grid item xs={12} sm={7}>
                        <Box width='auto' marginTop={['15px', '15px', '15px', '15px']}>
                            <ContextualNotification
                                width='100%'
                                title=''
                                variant='error'
                                iconAriaLabel='error'
                                marginTop={4}
                                onClose={() => setShowError({ ...showError, ansError: false })}
                            >
                                {showErrorLabel.ansError}
                            </ContextualNotification>
                        </Box>
                    </Grid>
                ) : null}

                <Grid container>
                    <Grid container>
                        <Box marginTop={['10px', '10px', '10px', '24px']}>
                            <Typography variant='h2'>{t('registrationPageOne.setup')}</Typography>
                        </Box>
                    </Grid>
                    <Grid container>
                        <Box marginTop={['5px', '5px', '5px', '10px']}>
                            <Typography variant='body1'>{t('registrationPageOne.setup_label')}</Typography>
                        </Box>
                    </Grid>

                    <Grid container>
                        <Grid item xs={12} sm={3}></Grid>
                        <Grid item xs={12} sm={4}>
                            <Box marginTop={['5px', '5px', '5px', '24px']} display='flex' flexDirection='row-reverse'>
                                <Typography variant='body1'>{t('paymentBankDetails.mandatoryFields')}</Typography>
                            </Box>
                        </Grid>
                    </Grid>

                    <Grid container>
                        <Field name='reg1-textBox-pwd'>
                            <Grid item xs={12} sm={2}>
                                <LabelBox>
                                    <FieldLabel variant='body1'>{t('registrationPageOne.pwd')} * &nbsp;</FieldLabel>
                                    <HoverTip
                                        content={t('registrationPageOne.tooltip1')}
                                        ariaLabel={t('registrationPageOne.tooltip1_info')}
                                        id='registration1-tooltip-password'
                                    ></HoverTip>
                                </LabelBox>
                            </Grid>

                            <Grid item xs={12} sm={5}>
                                <TextInputBox>
                                    <TextInput
                                        aria-describedby='reg1-inline-error-newPwd'
                                        className={showError.newPwdError ? 'hasError' : ''}
                                        type='password'
                                        placeholder={t('registrationPageOne.pleaseEnterYourPassword')}
                                        onChange={(event) => {
                                            setNewPwd(event.value);
                                        }}
                                        value={newPwd}
                                        onBlur={() => {
                                            validatePwd(showError, showErrorLabel);
                                        }}
                                        invalid={showError.newPwdError}
                                    />
                                </TextInputBox>
                                {showError.newPwdError ? (
                                    <InlineNotificationComponent id='reg1-inline-error-newPwd' title='' content={showErrorLabel.newPwdErrorLabel} />
                                ) : null}
                            </Grid>
                        </Field>
                    </Grid>

                    <Grid container>
                        <Field name='reg1-textBox-cnfpwd'>
                            <Grid item xs={12} sm={2}>
                                <LabelBox>
                                    <FieldLabel variant='body1'>{t('registrationPageOne.cnf_pwd')} *</FieldLabel>
                                </LabelBox>
                            </Grid>
                            <Grid item xs={12} sm={5}>
                                <TextInputBox>
                                    <TextInput
                                        aria-describedby='reg1-inline-error-cnfPwd'
                                        className={showError.cnfPwdError ? 'hasError' : ''}
                                        type='password'
                                        placeholder={t('registrationPageOne.pleaseConfirmYourPassword')}
                                        onChange={(event) => {
                                            setCnfPwd(event.value);
                                        }}
                                        value={cnfPwd}
                                        onBlur={() => {
                                            validateCnfPwd(showError, showErrorLabel);
                                        }}
                                        invalid={showError.cnfPwdError}
                                    />
                                </TextInputBox>
                                {showError.cnfPwdError ? (
                                    <InlineNotificationComponent id='reg1-inline-error-cnfPwd' title='' content={showErrorLabel.cnfPwdErrorLabel} />
                                ) : null}
                            </Grid>
                        </Field>
                    </Grid>

                    <Grid container>
                        <Grid item>
                            <Box marginTop={['5px', '5px', '5px', '30px']}>
                                <Typography variant='h2'>{t('registrationPageOne.provide_details')}</Typography>
                            </Box>
                        </Grid>
                    </Grid>

                    <Grid container>
                        <Grid item xs={12} sm={6}>
                            <Box marginTop={['5px', '5px', '5px', '10px']} marginBottom={['5px', '5px', '5px', '5px']}>
                                <Typography variant='body1'>{t('registrationPageOne.enter_details')}</Typography>
                            </Box>
                        </Grid>
                    </Grid>

                    <div style={{ width: '100%' }}>
                        <HorizontalLine />
                    </div>

                    <div role='group' aria-labelledby='sec1' style={{ width: '100%' }}>
                        <Grid container>
                            <Grid item>
                                <Box marginTop={['5px', '5px', '5px', '5px']}>
                                    <Typography variant='body1' id='sec1'>
                                        <b>{t('registrationPageOne.sec_que_one')}</b>
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>

                        <Grid container>
                            <Field name='reg1-dropdown-que1'>
                                <Grid item xs={12} sm={2}>
                                    <LabelBox>
                                        <FieldLabel variant='body1' id='reg1-dropdown-que1'>
                                            {t('registrationPageOne.que')} *
                                        </FieldLabel>
                                    </LabelBox>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <TextInputBox>
                                        <NativeDropdown
                                            ariaLabelledby='reg1-dropdown-que1'
                                            ariaDescribedby='reg1-inline-error-que1'
                                            className={showError.queOne ? 'hasError' : ''}
                                            id='reg1-dropdown-que1-field'
                                            width='100%'
                                            options={queList}
                                            onChange={(selectedOption) => {
                                                console.log('Selected option received from Registration1', selectedOption);
                                                handleQueOne(selectedOption);
                                            }}
                                            aria-describedby='reg1-inline-error-ans1'
                                            invalid={showError.queOne}
                                            value={secDetails.queOne ? secDetails.queOne.value : null}
                                        />
                                        {/**                                        <ReactSelect
                                            // className={showError.queOne ? 'hasError' : ''}
                                            id='reg1-dropdown-que1-field'
                                            value={secDetails.queOne}
                                            width='100%'
                                            isSearchable
                                            options={queList}
                                            onChange={handleQueOne}
                                            aria-describedby='reg1-inline-error-ans1'
                                        /> */}
                                    </TextInputBox>
                                    {showError.queOne ? (
                                        <InlineNotificationComponent id='reg1-inline-error-que1' title='' content={showErrorLabel.queOneLabel} />
                                    ) : null}
                                </Grid>
                            </Field>
                        </Grid>

                        <Grid container>
                            <Field name='reg1-textfield-ans1'>
                                <Grid item xs={12} sm={2}>
                                    <LabelBox>
                                        <FieldLabel variant='body1'>{t('registrationPageOne.ans')} *</FieldLabel>
                                    </LabelBox>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <TextInputBox>
                                        <TextInput
                                            aria-describedby='reg1-inline-error-ans1'
                                            className={showError.ansOne || showError.queOne ? 'hasError' : ''}
                                            onChange={(event) => {
                                                setSecDetails({ ...secDetails, ansOne: event.value });
                                            }}
                                            onBlur={() => {
                                                validateAnsOne(showError, showErrorLabel);
                                            }}
                                            value={secDetails.ansOne}
                                            invalid={showError.ansOne}
                                        />
                                    </TextInputBox>
                                    {showError.ansOne ? (
                                        <InlineNotificationComponent id='reg1-inline-error-ans1' title='' content={showErrorLabel.ansOneLabel} />
                                    ) : null}
                                </Grid>
                            </Field>
                        </Grid>
                    </div>

                    <div style={{ width: '100%' }}>
                        <HorizontalLine />
                    </div>

                    <div role='group' aria-labelledby='sec2' style={{ width: '100%' }}>
                        <Grid container>
                            <Box marginTop={['5px', '5px', '5px', '5px']}>
                                <Typography variant='body1' id='sec2'>
                                    <b>{t('registrationPageOne.sec_que_two')}</b>
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid container>
                            <Field name='reg1-dropdown-que2'>
                                <Grid item xs={12} sm={2}>
                                    <LabelBox>
                                        <FieldLabel variant='body1' id='reg1-dropdown-que2'>
                                            {t('registrationPageOne.que')} *
                                        </FieldLabel>
                                    </LabelBox>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <TextInputBox>
                                        <NativeDropdown
                                            ariaLabelledby='reg1-dropdown-que2'
                                            ariaDescribedby='reg1-inline-error-que2'
                                            className={showError.queTwo ? 'hasError' : ''}
                                            id='reg1-dropdown-que2-field'
                                            width='100%'
                                            options={queList}
                                            onChange={(selectedOption) => {
                                                console.log('Selected option received from Registration1', selectedOption);
                                                handleQueTwo(selectedOption);
                                            }}
                                            aria-describedby='reg1-inline-error-ans2'
                                            invalid={showError.queTwo}
                                            value={secDetails.queTwo ? secDetails.queTwo.value : null}
                                        />
                                        {/**                                        <ReactSelect
                                            className={showError.queTwo ? 'hasError' : ''}
                                            id='reg1-dropdown-que2-field'
                                            value={secDetails.queTwo}
                                            width='100%'
                                            isSearchable
                                            options={queList}
                                            onChange={handleQueTwo}
                                            aria-describedby='reg1-inline-error-ans2'
                                        /> */}
                                        {showError.queTwo ? (
                                            <InlineNotificationComponent id='reg1-inline-error-que2' title='' content={showErrorLabel.queTwoLabel} />
                                        ) : null}
                                    </TextInputBox>
                                </Grid>
                            </Field>
                        </Grid>

                        <Grid container>
                            <Field name='reg1-textfield-ans2'>
                                <Grid item xs={12} sm={2}>
                                    <LabelBox>
                                        <FieldLabel variant='body1'>{t('registrationPageOne.ans')} *</FieldLabel>
                                    </LabelBox>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <TextInputBox>
                                        <TextInput
                                            aria-describedby='reg1-inline-error-ans2'
                                            className={showError.ansTwo ? 'hasError' : ''}
                                            onChange={(event) => {
                                                setSecDetails({ ...secDetails, ansTwo: event.value });
                                            }}
                                            onBlur={() => {
                                                validateAnsTwo(showError, showErrorLabel);
                                            }}
                                            invalid={showError.ansTwo}
                                            value={secDetails.ansTwo}
                                        />
                                    </TextInputBox>
                                    {showError.ansTwo ? (
                                        <InlineNotificationComponent id='reg1-inline-error-ans2' title='' content={showErrorLabel.ansTwoLabel} />
                                    ) : null}
                                </Grid>
                            </Field>
                        </Grid>
                    </div>

                    <div style={{ width: '100%' }}>
                        <HorizontalLine />
                    </div>

                    <div role='group' aria-labelledby='sec3' style={{ width: '100%' }}>
                        <Grid container>
                            <Box marginTop={['5px', '5px', '5px', '5px']}>
                                <Typography variant='body1' id='sec3'>
                                    <b>{t('registrationPageOne.sec_que_three')}</b>
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid container>
                            <Field name='reg1-dropdown-que3'>
                                <Grid item xs={12} sm={2}>
                                    <LabelBox>
                                        <FieldLabel variant='body1' id='reg1-dropdown-que3'>
                                            {t('registrationPageOne.que')} *
                                        </FieldLabel>
                                    </LabelBox>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <TextInputBox>
                                        <NativeDropdown
                                            ariaLabelledby='reg1-dropdown-que3'
                                            ariaDescribedby='reg1-inline-error-que3'
                                            className={showError.queThree ? 'hasError' : ''}
                                            id='reg1-dropdown-que3-field'
                                            width='100%'
                                            options={queList}
                                            onChange={(selectedOption) => {
                                                console.log('Selected option received from Registration1', selectedOption);
                                                handleQueThree(selectedOption);
                                            }}
                                            aria-describedby='reg1-inline-error-ans3'
                                            invalid={showError.queThree}
                                            value={secDetails.queThree ? secDetails.queThree.value : null}
                                        />
                                        {/**                                        <ReactSelect
                                            className={showError.queThree ? 'hasError' : ''}
                                            width='100%'
                                            value={secDetails.queThree}
                                            id='reg1-dropdown-que3-field'
                                            isSearchable
                                            options={queList}
                                            onChange={handleQueThree}
                                            aria-describedby='reg1-inline-error-ans3'
                                        /> */}
                                        {showError.queThree ? (
                                            <InlineNotificationComponent
                                                id='reg1-inline-error-que3'
                                                title=''
                                                content={showErrorLabel.queThreeLabel}
                                            />
                                        ) : null}
                                    </TextInputBox>
                                </Grid>
                            </Field>
                        </Grid>

                        <Grid container>
                            <Field name='reg1-textfield-ans3'>
                                <Grid item xs={12} sm={2}>
                                    <LabelBox>
                                        <FieldLabel variant='body1'>{t('registrationPageOne.ans')} *</FieldLabel>
                                    </LabelBox>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <TextInputBox>
                                        <TextInput
                                            className={showError.ansThree ? 'hasError' : ''}
                                            onChange={(event) => {
                                                setSecDetails({ ...secDetails, ansThree: event.value });
                                            }}
                                            onBlur={() => {
                                                validateAnsThree(showError, showErrorLabel);
                                            }}
                                            aria-describedby='reg1-inline-error-ans3'
                                            invalid={showError.ansThree}
                                            value={secDetails.ansThree}
                                        />
                                    </TextInputBox>
                                    {showError.ansThree ? (
                                        <InlineNotificationComponent id='reg1-inline-error-ans3' title='' content={showErrorLabel.ansThreeLabel} />
                                    ) : null}
                                </Grid>
                            </Field>
                        </Grid>
                    </div>

                    <div style={{ width: '100%' }}>
                        <HorizontalLine color='DCDCDC'></HorizontalLine>
                    </div>
                    <Grid container>
                        <Grid item xs={12} md='auto'>
                            <Box display='flex' flexDirection='row'>
                                <Box marginLeft={['0px', '0px', '0px', '5px']} marginTop={['10px', '10px', '10px', '10px']}>
                                    <NativeCheckbox
                                        hasError={showError.showSDerror}
                                        ariaDescribedby='reg1-inline-error-sd'
                                        variant='light.small'
                                        id='reg1-checkB-saveDetails'
                                        label={t('registrationPageOne.save_details_cb')}
                                        checked={saveDetails}
                                        onChange={(event) => {
                                            handleSaveDetails(event);
                                        }}
                                    />
                                </Box>
                            </Box>
                            {showError.showSDerror ? (
                                <InlineNotificationComponent id='reg1-inline-error-sd' title='' content={showErrorLabel.showSDerrorLabel} />
                            ) : null}
                        </Grid>
                    </Grid>
                    <div style={{ width: '100%' }}>
                        <HorizontalLine />
                    </div>
                    <Grid container>
                        <Grid item xs={12} md={6}>
                            <Box display='flex' flexDirection='row'>
                                <Box marginLeft={['0px', '0px', '0px', '5px']} marginTop={['10px', '10px', '10px', '10px']}>
                                    <NativeCheckbox
                                        variant='light.small'
                                        id='reg1-checkB-autoPay'
                                        label={t('registrationPageOne.autopay_cb')}
                                        checked={autoPay}
                                        onChange={(event) => {
                                            handleAutoPay(event);
                                        }}
                                    />
                                </Box>
                                <Box marginTop={['10px', '10px', '10px', '12px']} marginLeft='1em'>
                                    <HoverTip
                                        content={t('registrationPageOne.tooltip2')}
                                        ariaLabel={t('registrationPageOne.tooltip2_info')}
                                        id='registration1-tooltip-autopay'
                                    ></HoverTip>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>

                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Box marginTop={2} style={{ float: 'right' }}>
                                <Button
                                    id='reg1-submit-button'
                                    onClick={() => {
                                        callContinue();
                                    }}
                                    variant='light.primary'
                                >
                                    {t('registrationPageOne.continue')}
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Modal
                open={open}
                onHide={() => setOpen(false)}
                closeIcon={true}
                onClickCloseIcon={() => setOpen(false)}
                size='small'
                activeFocusTrap={true}
                aria-labelledby='title1'
                minHeight='200px'
            >
                <Box display='flex' alignItems='center' justifyContent='center'>
                    <Icon name='StatusWarningLight' size='28px' mr='10px' />
                    <Typography variant='body1'>Please select a different question</Typography>
                </Box>

                <Box
                    position='absolute'
                    bottom='0'
                    py='1em'
                    width='calc(100% - 80px)'
                    display='flex'
                    justifyContent='center'
                    borderTop='1px solid #333'
                >
                    <Button onClick={() => setOpen(false)}>OK</Button>
                </Box>
            </Modal>
        </StyledDiv>
    );
};

export default Registration1;
